import { validateNumberInterval, ValidatorResult } from '../../validator';

import { convertMinMax } from './convertMinMax';

export const validateMinMaxValue = ({
  max,
  min
}: {
  min: string;
  max: string;
}): ValidatorResult => {
  const minNumber = convertMinMax(min);
  const maxNumber = convertMinMax(max);
  if (maxNumber === null || minNumber === null) {
    return null;
  }
  return validateNumberInterval(minNumber, maxNumber);
};

export const stringFilterErrors = {
  INVALID_VALUE: 'Значение меньше нуля'
};

export const validateStringFilterValue = (value: string): ValidatorResult => {
  const actualValue = convertMinMax(value);
  if (actualValue === null) {
    return null;
  }
  return actualValue < 0 ? stringFilterErrors.INVALID_VALUE : null;
};
